module.exports = __webpack_public_path__ + "assets/img/principal.55ecf99b.png";